import dayjs from "dayjs";
import { useUserEmail } from "../../../../context/UserEmailContext";

import { trackAnnouncementResourceClickForUser } from "../utils/announcementService";
import { formatAnnouncementDate } from "../utils/utils";

const normaliseValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const AnnouncementCard = ({
  announcement,
  variant = "default",
  userRole = "",
  userName = "",
}) => {
  const { userEmail } = useUserEmail();
  const safeUserEmail = normaliseValue(userEmail);
  const imageUrl = announcement?.headerImageFiles?.[0]?.url;
  const dateLabel = formatAnnouncementDate(announcement);

  const handleOpenResource = (e) => {
    e.stopPropagation();

    const documentUrl = announcement?.documentFiles?.[0]?.url;
    const url = announcement?.url;

    const targetUrl = documentUrl || url;
    const actionType = documentUrl ? "document" : "url";
    const announcementId = announcement?.id || announcement?.announcementId;

    if (targetUrl) {
      if (announcementId && safeUserEmail) {
        trackAnnouncementResourceClickForUser({
          announcementId,
          userEmail: safeUserEmail,
          userRole,
          userName,
          source: "dashboard",
          actionType,
          actionUrl: targetUrl,
        }).catch((error) => {
          console.error(
            "[AnnouncementCard] Failed to track read more click:",
            error,
          );
        });
      } else {
        console.warn("[AnnouncementCard] Skipped read more tracking", {
          announcementId,
          userEmail: safeUserEmail,
        });
      }

      window.open(targetUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <article
      className={`dashboard-announcement-card dashboard-announcement-card--${variant}`}
    >
      {imageUrl && (
        <div className="dashboard-announcement-image-wrap">
          <img
            src={imageUrl}
            alt={announcement?.contentTitle || "Announcement"}
            className="dashboard-announcement-image"
          />
        </div>
      )}

      <div className="dashboard-announcement-body">
        <div className="dashboard-announcement-meta-row">
          <span className="FP_Help_Text primary uppercase">
            {announcement?.contentType || "Announcement"}
          </span>

          {dateLabel && (
            <span className="FP_Help_Text grey">
              {dayjs(dateLabel).isValid()
                ? dayjs(dateLabel).format("DD MMM YYYY")
                : ""}
            </span>
          )}
        </div>

        <div className="FP_Body_Semibold grey">
          {announcement?.contentTitle || "Announcement"}
        </div>

        <p className="FP_Content grey">{announcement?.content || ""}</p>

        {(announcement?.url || announcement?.documentFiles?.[0]?.url) && (
          <button
            type="button"
            className="announcement-popup-resource-button FP_Content primary"
            onClick={handleOpenResource}
          >
            Read more
          </button>
        )}
      </div>
    </article>
  );
};

export default AnnouncementCard;
